import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  const cycle = () => {
    if (theme === "dark") setTheme("light");
    else if (theme === "light") setTheme("system");
    else setTheme("dark");
  };

  const Icon = theme === "light" ? Sun : theme === "dark" ? Moon : Monitor;
  const label = theme === "light" ? "Clair" : theme === "dark" ? "Sombre" : "Système";

  return (
    <button
      type="button"
      onClick={cycle}
      className={`p-2 rounded-md border border-[color:var(--border)] hover:bg-[color:var(--surface)] transition flex items-center gap-2 text-sm text-[color:var(--text-secondary)] ${className}`}
      title={`Thème : ${label}`}
      aria-label={`Changer le thème (${label})`}
    >
      <Icon size={16} />
      <span className="hidden lg:inline">{label}</span>
    </button>
  );
}
